import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ requiredPermission, children }) => {
  const { is_super, is_admin, permissions } = useSelector(
    (state) => state.GlobalVariables
  );

  // If the user is an admin or super admin, allow access to all routes
  if (is_super || is_admin) {
    return children;
  }

  // Check if the user has the required permission
  if (permissions?.includes(requiredPermission)) {
    return children;
  }

  // Redirect if the user doesn't have access
  return <Navigate to="/not-authorized" />;
};

export default ProtectedRoute;
